export default [
    {
        path: '/',
        meta: {},
        component: () => import('@/views/34/index')
    },
    {
        path: '/clerk/updateTags',
        meta: {
            title: '修改标签',
            menuName:'我的资料',
            menuPermission:'info'
        },
        component: () => import('@/views/34/clerk/updateTags')
    },
]
